import { a as __rest } from '../../tslib.es6.esm.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useId } from 'react';
import * as NavigationMenu from '@radix-ui/react-navigation-menu';
import { Step } from './Step.esm.js';
import stepIndicatorStyles from './StepIndicator.styles.esm.js';

const getStepLocation = (stepNumber, stepAmount) => {
    return stepNumber === 1
        ? "start"
        : stepNumber === stepAmount
            ? "end"
            : "middle";
};
const isLinkMode = (props) => {
    return props.stepList.every((step) => typeof step.href === "string" && step.href);
};
const StepIndicator = (props) => {
    const { id, className, currentStep, inverse = false, maxVisitedStepNumber = currentStep, showLabel = true, stepList, "aria-label": ariaLabel = "Progress", onStepChange } = props, rest = __rest(props, ["id", "className", "currentStep", "inverse", "maxVisitedStepNumber", "showLabel", "stepList", "aria-label", "onStepChange"]);
    const generatedId = useId();
    const styles = stepIndicatorStyles({ inverse });
    const isLink = isLinkMode(props);
    const stepAmount = stepList.length;
    const currentStepLabel = stepList[currentStep - 1].label;
    const getStepState = (stepNumber) => {
        if (stepNumber === currentStep)
            return "active";
        if (stepNumber < currentStep)
            return "complete";
        if (!isLink && stepNumber <= maxVisitedStepNumber)
            return "visited";
        return "disabled";
    };
    return (jsxs(NavigationMenu.Root, Object.assign({ id: id || generatedId, "aria-label": ariaLabel || "Progress", className: className }, rest, { children: [jsx(NavigationMenu.List, { asChild: true, "data-orientation": undefined, className: styles.stepIndicatorContainer(), children: jsx("ol", { children: stepList === null || stepList === void 0 ? void 0 : stepList.map((stepData, index) => {
                        const stepNumber = index + 1;
                        const stepState = getStepState(stepNumber);
                        const commonProps = {
                            id: stepData === null || stepData === void 0 ? void 0 : stepData.id,
                            className: stepData.className,
                            inverse: inverse,
                            showLabel: showLabel,
                            stepAmount: stepList.length,
                            stepLabel: stepData.label,
                            stepNumber: stepNumber,
                            stepState: stepState,
                            stepLocation: getStepLocation(stepNumber, stepAmount),
                            "aria-label": stepData["aria-label"],
                            onClick: onStepChange,
                        };
                        const ButtonProps = Object.assign({}, commonProps);
                        const LinkProps = Object.assign(Object.assign({}, commonProps), { href: stepData.href });
                        return (jsx(Step, Object.assign({}, (isLink ? LinkProps : ButtonProps)), stepNumber));
                    }) }) }), jsx("div", { className: "iris:sr-only", "aria-live": "polite", "aria-hidden": currentStep > stepAmount, children: `Step ${currentStep} of ${stepAmount}: ${currentStepLabel}, current step` })] })));
};
StepIndicator.displayName = "stepIndicator";

export { StepIndicator };
